import classNames from 'classnames'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { modifiedFieldsExt } from 'legacy/lut/classes/models/IFormProfile'
import React from 'react'
import { useSelector } from 'react-redux'

import { IForm } from 'core-components/classes/models/IForm'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'
import { selectRoles } from 'core-components/sitebuilder/store/selectors/selectRoles'
import { VisualAudience } from 'core/components/shared/ui/VisualAudience'

import { WidgetContactEditDialog } from '../../contactEditDialog/ContactEditDialog'

import { getCountEmptyFields } from './tileBlocksMethods'

import styles from './RenderCardHead.module.scss'

export default function RenderCardHead(props: { item: DataModel | IForm }) {
  const { item } = props
  const [dialogItem, setDialogItem] = React.useState<DataModel | IForm>()
  const roles = useSelector(selectRoles)
  let progress = 0

  modifiedFieldsExt.forEach((fieldName) => {
    if ((item.get(fieldName) || '').length) {
      progress += 1
    }
  })
  const percentageFilled = Math.round((progress / modifiedFieldsExt.length) * 100)

  return (
    <div className={styles.root}>
      <Tooltip className={styles.item} tipContent={() => <>{getCountEmptyFields(item)}</>}>
        <div className={styles.progress}>
          {progressRing(percentageFilled)}
          <span className={styles.progress__label}>{percentageFilled}</span>
        </div>
      </Tooltip>
      <Button
        className={classNames(styles.item, styles.editBtn)}
        variant={'text'}
        color={'grey'}
        iconButton={'kbase kbase-menu-dots'}
        onClick={() => setDialogItem(item)}
      />
      {dialogItem && dialogItem.get('ContactID') && (
        <VisualAudience<any>
          read={['Read Only']}
          write={roles.map((el) => el.id).filter((el: string) => el !== 'Read Only')}
          component={WidgetContactEditDialog}
          dialogEntryId={dialogItem.get('ContactID')}
          entryIdItem={dialogItem}
          onClose={() => {
            setDialogItem(undefined)
          }}
        />
      )}
    </div>
  )
}

const progressRing = (percent: number) => {
  const radius = 13
  const size = '15'
  const circumference = radius * 2 * Math.PI
  const progress = percent ? circumference - (percent / 100) * circumference : 0
  return (
    <svg className={styles.progress__svg} width={+size * 2} height={+size * 2}>
      <circle stroke="#ddd" strokeWidth="2" fill="transparent" r={radius} cx={size} cy={size} />
      <circle stroke={'#fff'} strokeWidth="2" fill="transparent" r={radius} cx={size} cy={size} />
      <circle
        stroke={'#0096d6'}
        strokeWidth="2"
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={progress}
        fill="transparent"
        r={radius}
        cx={size}
        cy={size}
      />
    </svg>
  )
}
